/**
 * Check if the date is Expired from current Date
 * @param {Date} date
 */
export function expiredFromNow(date: Date) {
  return date.valueOf() < Date.now().valueOf();
}
